<template>
	<el-button v-if="isshow" icon="el-icon-refresh-right" circle size="mini" @click.native="resetfiltercb"></el-button>
</template>

<script>
export default {
	name:'searchinput',
	props: {
		l_id: {
			type: String,
			default:''
		}
	},
	data() {
		return {
			isshow:false
		}
	},
	mounted() {
		this.init();
	},
	methods:{
		init(){
			var that=this;
			this.$apipost.get.GetFilterSet({l_id:this.l_id,type:'重置'}).then(res => {
				//debugger
				if(res.state=='1')
					that.isshow=true;
				this.$emit('sethandelshow',{type:'reset',show:res.state=='1'});
			}).catch(e=>{
				
			});
		},
		resetfiltercb(){
			this.$emit('resetfiltercb',{});
		}
	}
}
</script>

<style>
</style>
